import Toast from '@/components/ui/Toast';

let disabled = false;

export default class DBStorage {
  static async init(dbName = 'LocalSAV', storeName = 'inquiries') {
    if (!(window !== 'undefined' && 'indexedDB' in window && window.indexedDB !== null)) {
      disabled = true;
      Toast.error('Lokale Datenspeicherung ist nicht unterstützt<br/>Bitte kontaktieren Sie den Support.');
    }
    this.dbName = dbName;
    this.storeName = storeName;
    this.dbPromise = null;
  }

  static async getDatabase() {
    if (this.dbPromise) return this.dbPromise;

    this.dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          const store = db.createObjectStore(this.storeName, { keyPath: 'uuid' });
          store.createIndex('identifier', 'identifier', { unique: false });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => {
        this.dbPromise = null;
        reject(request.error);
      };
    });
    return this.dbPromise;
  }

  static async set(record) {
    if (disabled) return null;
    const db = await this.getDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const request = store.put(record);
      request.onsuccess = () => resolve(true);
      request.onerror = () => reject(request.error);
    });
  }

  static async get(uuid) {
    if (disabled) return null;
    if (!uuid) return null;
    const db = await this.getDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(this.storeName, 'readonly');
      const store = transaction.objectStore(this.storeName);
      const request = store.get(uuid);

      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
    });
  }

  static async delete(uuid) {
    if (disabled) return null;
    const db = await this.getDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const request = store.delete(uuid);

      request.onsuccess = () => resolve(true);
      request.onerror = () => reject(request.error);
    });
  }
}
